import { render, staticRenderFns } from "./ModalOpcoesDownload.vue?vue&type=template&id=f1120818&scoped=true"
import script from "./ModalOpcoesDownload.vue?vue&type=script&lang=js"
export * from "./ModalOpcoesDownload.vue?vue&type=script&lang=js"
import style0 from "./ModalOpcoesDownload.vue?vue&type=style&index=0&id=f1120818&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1120818",
  null
  
)

export default component.exports